export default "__VITE_ASSET__DjQXGK53__"